<div class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">{{ dataService.res("Ubt-TreeList-Roles") }}</h2>
    </div>
    <div
      *appCheckPermission="{
        context: PermissionContext.Roles,
        action: Action.CREATE,
      }"
    >
      <div fxLayout="column" class="add-button-style">
        <abc-speed-dial-action icon="add" (onClick)="assignNewRole()">
        </abc-speed-dial-action>
      </div>
    </div>
  </div>
  <div class="content-block">
    <div class="dx-card responsive-paddings card-radius">
      <abc-grid
        #rolesGrid
        class="grid-group-by-Style"
        [height]="'100%'"
        [dataSource]="availableRoles"
        [noDataText]="noDataText"
        [setupDefaultLayoutOnInitialization]="true"
        [rowAlternationEnabled]="false"
        [columns]="columnsHeader"
        [showRowLines]="false"
        (onSaving)="saveRow($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onCellClick)="onCellClick($event)"
        (onExporting)="dataService.onExporting($event, exportFileName)"
      >
        <dxo-export
          [enabled]="true"
          [allowExportSelectedData]="false"
          [formats]="['pdf', 'xlsx']"
        ></dxo-export>
        <dxo-column-chooser [enabled]="false"> </dxo-column-chooser>
        <dxo-editing
          [useIcons]="true"
          [mode]="'row'"
          [allowAdding]="false"
          [allowDeleting]="true"
          [allowUpdating]="true"
        ></dxo-editing>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-search-panel [visible]="true"> </dxo-search-panel>
      </abc-grid>
    </div>
  </div>
</div>

<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
<abc-popup
  #confirmDeletePopup
  [width]="'90%'"
  [maxWidth]="700"
  fxLayout="column"
  fxLayoutAlign="center center"
  [height]="'auto'"
  [title]="dataService.res('Ubt-MeasureList-Confirm-Delete')"
  [showCloseButton]="true"
>
  <div
    class="dx-card popup-card-paddings card-radius"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="20px"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayoutGap="20px"
      class="text-center"
    >
      {{ dataService.res("Role-Message-Delete") }}
    </div>
    <dxi-item
      itemType="group"
      fxLayout="row"
      fxLayoutAlign="center end"
      fxLayoutGap="20px"
    >
      <dx-button
        class="submit-button"
        [text]="dataService.res('Ubt-MeasureList-Yes')"
        (onClick)="removeRow()"
      >
      </dx-button>
      <dx-button
        class="cancel-button"
        [text]="dataService.res('Ubt-MeasureList-No')"
        (onClick)="abortDelete()"
      >
      </dx-button>
    </dxi-item>
  </div>
</abc-popup>
